<app-navbar [title]="'Historia'">
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<table class="table table-striped table-hover">
	<thead>
		<tr class="table-dark">
			<th>Data</th>
			<th>Osoba</th>
			<th>Kategoria</th>
			<th>Informacja</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of history">
			<td>
				{{ item.date | formatDateTime }}
			</td>
			<td>
				{{ item.user }}
			</td>
			<td>
				{{ item.category }}
			</td>
			<td>
				{{ item.message }}
			</td>
		</tr>
	</tbody>
</table>
